import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { ClientShell } from '@/components/clients/client-shell'
import { clientPagePath, pageForLegacyTab } from '@/lib/client-pages'

/**
 * Les pages d'un client (#285) : `/clients/{id}` (aperçu) et
 * `/clients/{id}/{page}`, sous un même bandeau. Les anciennes adresses à
 * onglet (`?tab=…`) restent valides : liens `oo:`, courriels et notifications
 * les portent. Elles redirigent vers la page, les autres paramètres gardés.
 */
export const Route = createFileRoute('/_app/clients/$clientId')({
  beforeLoad: ({ location, params }) => {
    const search = location.search as Record<string, unknown>
    if (!('tab' in search)) return
    const { tab, ...rest } = search
    throw redirect({
      href: `${clientPagePath(params.clientId, pageForLegacyTab(tab))}${searchString(rest)}`,
      replace: true,
    })
  },
  component: ClientLayout,
})

/** Les paramètres restants, tels quels. */
function searchString(search: Record<string, unknown>): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(search)) {
    if (value === undefined || value === null) continue
    params.set(key, typeof value === 'string' ? value : JSON.stringify(value))
  }
  const text = params.toString()
  return text ? `?${text}` : ''
}

function ClientLayout() {
  const { clientId } = Route.useParams()
  // La clé change avec le client : pas d'état d'un client à l'autre.
  return (
    <ClientShell key={clientId} clientId={clientId}>
      <Outlet />
    </ClientShell>
  )
}
